import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import is from 'is_js';
import AppContext from 'context/Context';
import FalconRoutes from 'routes';
import { CloseButton } from 'components/common/Toast';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';

const PAGE_TITLES = {
  '/': 'Gestodo',
  '/dashboard': 'Dashboard | Gestodo',
  '/posts': 'Publicaciones | Gestodo',
  '/posts/add': 'Nueva Publicación | Gestodo',
  '/posts/details': 'Detalle de Publicación | Gestodo',
  '/stock': 'Stock | Gestodo',
  '/sales': 'Ventas | Gestodo',
  '/sales/dashboard': 'Sales Dashboard | Gestodo',
  '/sales/pipeline': 'Sales Pipeline | Gestodo',
  '/sales/tasks': 'Sales Tasks | Gestodo',
  '/sales/accounts-to-activate': 'Accounts To Activate | Gestodo',
  '/sales/promo': 'Sales Promo | Gestodo',
  '/sales/reports': 'Sales Reports | Gestodo',
  '/sales/company': 'Company Profile | Gestodo',
  '/sales/opportunity': 'Opportunity Detail | Gestodo',
  '/claims': 'Reclamos | Gestodo',
  '/questions': 'Preguntas | Gestodo',
  '/messages': 'Mensajes | Gestodo',
  '/mercadolibre-messages': 'Post venta | Gestodo',
  '/agents': 'Agentes | Gestodo',
  '/integrations': 'Integraciones | Gestodo',
  '/calendar': 'Calendario | Gestodo',
  '/activity': 'Actividad | Gestodo',
  '/users': 'Usuarios | Gestodo',
  '/profiles': 'Perfiles | Gestodo',
  '/subscription': 'Suscripción | Gestodo',
  '/super-admin': 'Super Admin | Gestodo',
  '/partners': 'Partners | Gestodo',
  '/blog': 'Blog | Gestodo',
  '/blog/new': 'Nuevo Post | Gestodo',
  '/login': 'Iniciar Sesión | Gestodo',
  '/login/forgot-password': 'Recuperar Contraseña | Gestodo',
  '/login/reset-password': 'Restablecer Contraseña | Gestodo',
  '/login/confirm-mail': 'Confirmar Email | Gestodo',
  '/logout': 'Cerrar Sesión | Gestodo',
  '/lock-screen': 'Pantalla Bloqueada | Gestodo',
  '/waitlist': 'Lista de Espera | Gestodo',
  '/waitlist/status': 'Estado de Lista de Espera | Gestodo',
  '/trial-expired': 'Prueba Expirada | Gestodo',
  '/errors/404': 'Página no encontrada | Gestodo',
  '/errors/500': 'Error del servidor | Gestodo',
};

const getPageTitle = pathname => {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  const twoSegmentBase = '/' + pathname.split('/').slice(1, 3).join('/');
  if (PAGE_TITLES[twoSegmentBase]) return PAGE_TITLES[twoSegmentBase];
  // Match dynamic segments (e.g. /sales/123, /stock/abc)
  const base = '/' + pathname.split('/')[1];
  if (PAGE_TITLES[base]) return PAGE_TITLES[base];
  return 'Gestodo';
};

const PageTitleUpdater = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = getPageTitle(pathname);
  }, [pathname]);
  return null;
};

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  
  const {
    config: { navbarPosition }
  } = useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <PageTitleUpdater />
      <FalconRoutes />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.BOTTOM_LEFT}
      />
    </Router>
  );
};

export default App;
